const DEVICE_ID_STORAGE_KEY = "apit:device:id";

function createDeviceId() {
	if (typeof window !== "undefined" && window.crypto?.randomUUID) {
		return window.crypto.randomUUID();
	}

	return `device-${Date.now()}-${Math.random().toString(16).slice(2, 10)}`;
}

export function getOrCreateDeviceId() {
	if (typeof window === "undefined") {
		return "server-side-device";
	}

	let existingDeviceId = window.localStorage.getItem(DEVICE_ID_STORAGE_KEY);
	if (existingDeviceId) {
		return existingDeviceId;
	}

	existingDeviceId = createDeviceId();
	window.localStorage.setItem(DEVICE_ID_STORAGE_KEY, existingDeviceId);
	return existingDeviceId;
}

export function getClientPlatformLabel() {
	if (typeof window !== "undefined") {
		const desktopPlatform = window.apitDesktopRuntimeConfig?.clientPlatform;
		if (desktopPlatform) {
			return desktopPlatform;
		}
		if (window.apitDesktop) {
			return "apit-desktop";
		}
	}
	if (typeof navigator === "undefined") return "";
	return navigator.userAgentData?.platform || navigator.platform || "";
}
